// Globálny reaktívny stav pre loader — zdieľaný medzi router.js a PageLoader.vue
import { reactive } from 'vue';

export const loadingState = reactive({
    active: false,
});